import { render, staticRenderFns } from "./ModalEditCustomerComponent.vue?vue&type=template&id=4f113ace"
import script from "./ModalEditCustomerComponent.vue?vue&type=script&lang=js"
export * from "./ModalEditCustomerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports